/**
 * @file Reducer.
 */

import { default as actionTypes } from './actionTypes';
import { shallowUpdateState } from '../utilities';

export const INITIAL_STATE = Object.freeze({
	newPassword: ``,
	confirmPassword: ``,
	errorMessage: undefined,
	loading: false,
	success: false,
});

export default function reducer(state = INITIAL_STATE, action) {
	const { type, payload } = action;

	switch (type) {
		case actionTypes.START_CHANGE_PASSWORD_REQUEST:
			return shallowUpdateState(state, payload);

		case actionTypes.RECEIVE_SUCCESS_RESPONSE:
			return shallowUpdateState(state, payload);

		case actionTypes.RECEIVE_ERROR_RESPONSE:
			return shallowUpdateState(state, payload);

		case actionTypes.RESET:
			return shallowUpdateState(state, INITIAL_STATE);

		default:
			return state;
	}
}
